// PDFViewer.tsx
import React from 'react';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';

interface PDFViewerProps {
    fileUrl: string;
    height?: string;
}

const PDFViewer: React.FC<PDFViewerProps> = ({ fileUrl}) => {
    return (
        <div>
            {/* Use local worker file from public directory */}
            <Worker workerUrl="/pdf.worker.min.js">
                <Viewer fileUrl={fileUrl} />
            </Worker>
        </div>
    );
};

export default PDFViewer;
